import get from 'lodash.get';

import * as Actions from './rate-viewer.actions';
import { emptyArray, emptyObject } from 'ui-components/default-props/empty';
import { baseReducer as reducerMapper } from '../../store/core/base-reducer';

const initialState = {};

const mergeRates = (providerRate, rates) => {
  // Check if this provider already exists in the rates array
  const existingRateIndex = rates.findIndex(
    (rate) => providerRate.sellerLabelProviderId === rate.sellerLabelProviderId && !providerRate.serviceCollectionId,
  );

  // If it exists, update it
  if (existingRateIndex !== -1) {
    return rates.map((rate, index) => {
      if (index !== existingRateIndex) {
        return rate;
      }

      const rateUpdate = providerRate;
      const isLoading = false;
      return {
        ...rate,
        ...rateUpdate,
        isLoading,
      };
    });
  }

  // If it doesn't exist (e.g., service collections), append it
  return [
    ...rates,
    {
      ...providerRate,
      isLoading: false,
    },
  ];
};

const mergeRateErrors = (providerRateError, rates) => {
  return rates.map((rate) => {
    const isSameLabelProvider = (get(providerRateError, 'providerId') || '') === rate.labelProviderId;
    const shouldUpdate = rate.isLoading && isSameLabelProvider;
    if (!shouldUpdate) {
      return rate;
    }

    const isLoading = false;
    const { errorMessage } = rate;
    return {
      ...rate,
      rates: [],
      isLoading,
      errorMessage: errorMessage || providerRateError?.errorMessage,
    };
  });
};

const actionMap = {
  [Actions.RATE_VIEWER_START_LOADING_RATES]: (state, { jobGuid, rates }) => {
    return {
      ...state,
      rates,
      jobGuid,
      isLoading: false,
      errors: emptyArray,
    };
  },
  [Actions.RATE_VIEWER_START_LOADING_RATES_ERROR]: (state, { errors }) => {
    return {
      ...state,
      rates: [],
      jobGuid: undefined,
      isLoading: false,
      errors,
    };
  },
  [Actions.RATE_VIEWER_LOAD_RATES]: (state) => {
    return {
      ...state,
      rates: [],
      jobGuid: undefined,
      isLoading: true,
    };
  },
  [Actions.RATE_VIEWER_SELECT_RATE]: (state, { selectedRate }) => {
    return {
      ...state,
      selectedRate,
    };
  },
  [Actions.RATE_VIEWER_SELECT_SELLER_PROVIDER]: (state, { sellerProviderId }) => {
    return {
      ...state,
      selectedSellerProviderId: sellerProviderId,
    };
  },
  [Actions.RATE_VIEWER_ON_RATE_RECIEVED_SUCCESS]: (state, { providerRate }) => {
    const rates = get(state, 'rates', emptyArray);
    return {
      ...state,
      rates: mergeRates(providerRate, rates),
      isLoading: false,
    };
  },
  [Actions.RATE_VIEWER_ON_RATE_RECIEVED_ERROR]: (state, { providerRateError }) => {
    const rates = get(state, 'rates', emptyArray);
    return {
      ...state,
      rates: mergeRateErrors(providerRateError, rates),
      isLoading: false,
    };
  },
  [Actions.RATE_VIEWER_CLEAR]: () => undefined,
  [Actions.RATE_VIEWER_CLEAR_ERROR]: (state) => {
    return {
      ...state,
      errors: emptyArray,
    };
  },
};

const mappedReducer = reducerMapper(initialState, actionMap);

export const reducer = (state = {}, action) => {
  const rateViewerKey = get(action, 'rateViewerKey');
  if (!rateViewerKey) {
    return state;
  }

  const instances = get(state, 'instances', emptyObject);

  return {
    ...state,
    instances: {
      ...instances,
      [rateViewerKey]: mappedReducer(instances[rateViewerKey], action),
    },
  };
};

export { namespace } from './rate-viewer.reducer.metadata';
